import React, { useEffect, useState } from "react";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewIcon from "../../../components/Icons/ViewIcon";
import CommonTable from "../../../components/comman/CommonTable";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

const PendingSalaryTickets = ({ siteId }) => {
  const navigate = useNavigate();
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    salaryTicketList: [],
  });

  useEffect(() => {
      GetSalaryTicket();
  }, [siteId]);

  const GetSalaryTicket = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_salary_ticket + `pageNumber=1&pageSize=5&status=pending${siteId ? `&siteId=${siteId}`: ""}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.salaryTicket?.map((item) => ({
          ...item,
          salaryTicketNumber: item?.ticketNumber,
          siteName: item?.site?.name,
          createdOn: moment(item?.createdAt).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
          paymentStatus:
            item?.remainingAmount === item?.totalAmount
              ? 0
              : item?.remainingAmount === 0
              ? 1
              : 2,
          grandTotal: formatAmount(item?.totalAmount),
        }));
        setPageStates((pre) => ({
          ...pre,
          salaryTicketList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "salaryTicketNumber", label: "Ticket Number" },
    { value: "siteName", label: "Site Name" },
    { value: "month", label: "Month" },
    { value: "createdOn", label: "Created On" },
    { value: "createdBy", label: "Created By" },
    { value: "grandTotal", label: "Total Amount" },
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const HandleView = (data) => {
    navigate(RoutesLink.salary_ticket_detail + `/${data?.id}`);
  };

  const ActionDataForPending = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  return (
    <div className="col-12 col-lg-12">
      <div className="card ">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Pending Salary Tickets</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(RoutesLink?.salary_ticket)}
            >
              View All
            </button>
          </div>
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates?.salaryTicketList}
            ActionData={ActionDataForPending}
            isLoading={pageStates?.tableLoader}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingSalaryTickets;
